module.exports = __webpack_public_path__ + "img/hr-level2addon_idle_shadow.bef4d18a.png";